import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule} from '@angular/forms'; // ngModel exists here
import { AgmCoreModule } from '@agm/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { CitiesComponent } from './cities/cities.component';
import { ForecastService } from './forecast.service';


@NgModule({
  declarations: [
    AppComponent,
    CitiesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule ,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBthCgCKzwZGlNTIIFSYqahblH0n6aMgNw'
    })  
  ],
  providers: [ForecastService],
  bootstrap: [AppComponent]
})
export class AppModule { }
